export default "__VITE_ASSET__Ck7j82$E__"